// extracted by mini-css-extract-plugin
module.exports = {"Picture":"Picture_Picture___7T9z","isFallback":"Picture_isFallback__DDJ0o","Picture_asset":"Picture_Picture_asset__VqDiE","Picture___cover":"Picture_Picture___cover__bFfaQ"};